export { default, type ICheckboxBaseProps } from "./CheckboxBase";
